<ng-container *msShowInEpcot="false">
    @if (isEventSelected) {
        <span class="info-icon-container">
            <vn-icon name="theme-info-i" size="12" />
        </span>
    }
    <ms-dynamic-icon [html]="message()" />
</ng-container>
<ng-container *msShowInEpcot="true">
    @if (isEventSelected) {
        <ms-epcot-notification [message]="message()" [notificationType]="'info'" />
    } @else {
        <ms-dynamic-icon [html]="message()" />
    }
</ng-container>
